var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('the-sidebar'),_c('Notifications'),_c('v-main',[_c('v-toolbar',{staticClass:"mb-2",attrs:{"flat":""}},[_c('v-toolbar-title',[_c('h1',{staticClass:"text-h6 font-weight-bold"},[_vm._v(_vm._s(_vm.$t(_vm.pageTitle)))])])],1),_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }